import { IconType } from 'react-icons';
import { GoHome } from 'react-icons/go';
import { AiOutlineProduct } from 'react-icons/ai';
import { MdOutlineCategory } from 'react-icons/md';
import { LuFactory } from 'react-icons/lu';
import { PiFlagBannerBold } from 'react-icons/pi';
import { FaRegUser } from 'react-icons/fa';
import { TbLockAccess } from 'react-icons/tb';
import { FaTasks } from 'react-icons/fa';
import { MdOutlineCalculate } from 'react-icons/md';

export type RoleName =
  | 'admin'
  | 'employee'
  | 'CHRO'
  | 'CTO'
  | 'CFO'
  | 'CMO'
  | 'CRO'
  | 'website_administrator';

export interface SidebarItem {
  name: string;
  title: string;
  icon: IconType;
  url: string;
  roles: RoleName[];
}

export const SIDEBAR_ITEMS: SidebarItem[] = [
  {
    name: 'main',
    title: 'صفحه اصلی',
    icon: GoHome,
    url: '/',
    roles: [
      'admin',
      'employee',
      'CHRO',
      'CTO',
      'CFO',
      'CMO',
      'CRO',
      'website_administrator',
    ],
  },
  {
    name: 'products',
    title: 'محصولات',
    icon: AiOutlineProduct,
    url: '/product/list',
    roles: [
      'admin',
      'CHRO',
      'CTO',
      'CFO',
      'CMO',
      'CRO',
      'website_administrator',
    ],
  },
  {
    name: 'category',
    title: 'دسته‌بندی',
    icon: MdOutlineCategory,
    url: '/category/list',
    roles: ['admin', 'CHRO', 'CTO', 'CFO', 'CMO', 'CRO'],
  },
  {
    name: 'company',
    title: 'شرکت',
    icon: LuFactory,
    url: '/company/list',
    roles: [
      'admin',
      'CHRO',
      'CTO',
      'CFO',
      'CMO',
      'CRO',
      'website_administrator',
    ],
  },
  {
    name: 'banner',
    title: 'بنر',
    icon: PiFlagBannerBold,
    url: '/banner/list',
    roles: [
      'admin',
      'CHRO',
      'CTO',
      'CFO',
      'CMO',
      'CRO',
      'website_administrator',
    ],
  },
  {
    name: 'user',
    title: 'کاربران',
    icon: FaRegUser,
    url: '/user/list',
    roles: [
      'admin',
      'CHRO',
      'CTO',
      'CFO',
      'CMO',
      'CRO',
      'website_administrator',
    ],
  },
  {
    name: 'role',
    title: 'نقش‌ها',
    icon: TbLockAccess,
    url: '/role/list',
    roles: ['admin', 'CHRO', 'CTO', 'CFO', 'CMO', 'CRO'],
  },
  {
    name: 'task',
    title: 'وظایف روزانه',
    icon: FaTasks,
    url: '/task/list',
    roles: ['admin', 'employee', 'CHRO', 'CTO', 'CFO', 'CMO', 'CRO'],
  },
  {
    name: 'salary',
    title: 'محاسبه حقوق',
    icon: MdOutlineCalculate,
    url: '/salary',
    roles: ['admin', 'CHRO', 'CTO', 'CFO', 'CMO', 'CRO'],
  },
];

export const getSidebarsForRole = (
  roleName?: RoleName | null
): SidebarItem[] => {
  if (!roleName) return [];
  return SIDEBAR_ITEMS.filter((item) => item.roles.includes(roleName));
};
